<template>
    <BreadCrumb PageTitle="Faire un test" />
    <Test />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import Test from "@/components/test/Test.vue";
  
    export default defineComponent({
      name: "TestPage",
      components: {
        BreadCrumb,
        Test,
      },
    });
  </script>